import { OnInit, Component, ViewChild, ElementRef, HostListener } from "@angular/core";
import { TranslationsProvider } from "../../../core/translations.provider";
import { TranslateService } from "@ngx-translate/core";
import { languages } from './djiv-language.config';

@Component({
    selector: 'djiv-languages-drop-down',
    templateUrl: './djiv-languages-drop-down.component.html',
    styleUrls: ["./djiv-languages-drop-down.component.css"]
})

export class DJIVLanguagesDropDown implements OnInit {
    @ViewChild("djivLanguageMenu") languageMenu: ElementRef;
    @ViewChild("djivLanguageDropDown") languageDropDown: ElementRef;

    private selectedLanguage: {
        label: string,
        culture: string,
        order: number,
        key: string,
        flag: string
    };

    protected get languages() {
        return languages;
    }

    public constructor(private translationsProvider: TranslationsProvider, private translateService: TranslateService) {}

    public ngOnInit(): void {        
        const languageKey = this.translationsProvider.getLanguage();     
        this.selectedLanguage = languages.find((lang) => lang.key === languageKey) || languages[0];
        this.setCulture();
    }

    public setLanguage(language) {
        this.selectedLanguage = language;
        this.translationsProvider.setLanguage(this.selectedLanguage.key);
        this.translateService.use(this.selectedLanguage.key);
        this.translationsProvider.notify();
        this.setCulture();
        this.closeLanguageMenu()
    }

    private setCulture() {
        this.translationsProvider.setCulture(this.selectedLanguage.culture);
    }

    protected toggleLanguageMenu() {
        this.languageMenu.nativeElement.classList.toggle("showMenu");
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        // Check if click was outside of language dropdown so we can close it
        if (!this.languageDropDown.nativeElement.contains(targetElement)) {
            this.closeLanguageMenu();
        }
    }

    private closeLanguageMenu() {
        this.languageMenu.nativeElement.classList.remove("showMenu");
    }
}




// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-languages-drop-down/djiv-languages-drop-down.component.ts